/*
* Noomus custom JavaScript
* Site-wide scripts — keep inside IIFE to avoid global scope leaks.
*/

(function () {
  'use strict';

  // Product page ATC: price lives outside [data-add-to-cart-text] so theme.js
  // must not inject a second price into the label on variant change.
  if (document.body.classList.contains('template-product') && window.theme && theme.settings) {
    theme.settings.atcButtonShowPrice = false;
  }

  function normalizePhone(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function isValidUSPhone(value) {
    const digits = normalizePhone(value);
    if (digits.length === 10) return true;
    if (digits.length === 11 && digits.startsWith('1')) return true;
    return false;
  }

  function initPhoneValidation() {
    function initForm(form) {
      const subscribeBtn = form.querySelector('[name="subscribe"]');
      if (!subscribeBtn || form.dataset.phoneValidationInit === 'true') return;
      form.dataset.phoneValidationInit = 'true';

      const telInputs = Array.from(form.querySelectorAll('input[type="tel"]'));
      const fields = telInputs.map((input) => {
        const msg = document.createElement('span');
        msg.className = 'phone-validation-msg';
        msg.style.marginLeft = '8px';
        msg.style.fontSize = '14px';
        input.insertAdjacentElement('afterend', msg);
        return { input, msg };
      });

      function updateValidation() {
        let invalid = false;
        fields.forEach(({ input, msg }) => {
          const number = input.value.trim();
          const valid = number === '' || isValidUSPhone(number);
          input.setCustomValidity(valid ? '' : 'Enter a valid US phone number');
          msg.textContent = number === '' ? '' : valid ? 'Valid phone number' : 'Enter a valid US phone number';
          msg.style.color = valid ? 'green' : 'red';
          if (!valid) invalid = true;
        });
        subscribeBtn.disabled = invalid;
        subscribeBtn.style.opacity = invalid ? '0.6' : '1';
        subscribeBtn.style.cursor = invalid ? 'not-allowed' : 'pointer';
        return !invalid;
      }

      telInputs.forEach((input) => {
        input.addEventListener('input', updateValidation);
        input.addEventListener('change', updateValidation);
      });
      form.addEventListener('submit', (event) => {
        if (!updateValidation()) event.preventDefault();
      });
      updateValidation();
    }

    document.querySelectorAll('form').forEach(initForm);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('form').forEach(initForm);
    });
  }

  function initColGridLoadMore(root) {
    if (!root || root.dataset.colGridInit === 'true') return;
    root.dataset.colGridInit = 'true';

    const itemsContainer = root.querySelector('[data-col-grid-items]');
    const loadMoreBtn = root.querySelector('[data-col-grid-load-more]');
    if (!itemsContainer || !loadMoreBtn) return;

    const items = itemsContainer.querySelectorAll('.grid__item');
    if (items.length === 0) return;

    const columnsDesktop = parseInt(root.dataset.columnsDesktop, 10) || 4;
    const loadDesktop = parseInt(root.dataset.loadDesktop, 10) || 6;
    const desktopMq = window.matchMedia('(min-width: 768px)');

    let visibleCount = columnsDesktop;

    function updateVisibility() {
      if (!desktopMq.matches) {
        items.forEach((item) => item.removeAttribute('hidden'));
        loadMoreBtn.setAttribute('hidden', '');
        return;
      }

      items.forEach((item, index) => {
        if (index < visibleCount) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', '');
        }
      });

      if (visibleCount >= items.length) {
        loadMoreBtn.setAttribute('hidden', '');
      } else {
        loadMoreBtn.removeAttribute('hidden');
      }
    }

    function onBreakpointChange() {
      if (desktopMq.matches) {
        visibleCount = columnsDesktop;
      }
      updateVisibility();
    }

    loadMoreBtn.addEventListener('click', () => {
      visibleCount += loadDesktop;
      updateVisibility();
    });

    desktopMq.addEventListener('change', onBreakpointChange);
    updateVisibility();
  }

  function initAllColGrids(container) {
    const scope = container || document;
    scope.querySelectorAll('[data-col-grid]').forEach(initColGridLoadMore);
  }

  const DESKTOP_MQ = window.matchMedia('(min-width: 768px)');

  function syncTestimonialsViewportHeight(slider, isMobile) {
    const viewport = slider.querySelector('.flickity-viewport');
    const track = slider.querySelector('.flickity-slider');
    if (!viewport || !track) return;

    if (isMobile) {
      const h = track.scrollHeight || track.offsetHeight;
      if (h > 0) {
        viewport.style.height = `${h}px`;
      }
      return;
    }

    const flkty = window.theme?.Flickity?.data(slider);
    if (flkty && typeof flkty.resize === 'function') {
      flkty.resize();
    }
  }

  function bindTestimonialsMediaLoad(section, slider, isMobile) {
    const recalc = () => syncTestimonialsViewportHeight(slider, isMobile);

    slider.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', recalc, { once: true });
      img.addEventListener('error', recalc, { once: true });
    });

    slider.querySelectorAll('video').forEach((video) => {
      if (video.readyState >= 2) return;
      video.addEventListener('loadeddata', recalc, { once: true });
    });

    if (document.fonts && typeof document.fonts.ready?.then === 'function') {
      document.fonts.ready.then(recalc);
    }
  }

  function observeTestimonialsMobileHeight(section, slider) {
    if (section.dataset.twiRo === 'true') return;

    const track = slider.querySelector('.flickity-slider');
    const viewport = slider.querySelector('.flickity-viewport');
    if (!track || !viewport || typeof ResizeObserver === 'undefined') return;

    section.dataset.twiRo = 'true';
    const ro = new ResizeObserver(() => {
      if (DESKTOP_MQ.matches) return;
      syncTestimonialsViewportHeight(slider, true);
    });
    ro.observe(track);
  }

  function applyTestimonialsMobileZigzag(section, slider, isMobile) {
    const cols = parseInt(section.dataset.columnsMobile, 10) || 2;
    const track = slider.querySelector('.flickity-slider');
    if (!track) return;

    const items = track.querySelectorAll('[data-item]');

    items.forEach((item, i) => {
      if (isMobile && cols === 2) {
        const row = Math.floor(i / 2) + 1;
        const posInRow = i % 2;
        const col = row % 2 === 0 ? (posInRow === 0 ? 2 : 1) : (posInRow === 0 ? 1 : 2);
        item.style.gridRow = String(row);
        item.style.gridColumn = String(col);
      } else {
        item.style.removeProperty('grid-row');
        item.style.removeProperty('grid-column');
      }
    });
  }

  function setTestimonialsMobileGrid(section, slider, isMobile) {
    if (!slider) return;

    const apply = () => {
      applyTestimonialsMobileZigzag(section, slider, isMobile);
      syncTestimonialsViewportHeight(slider, isMobile);
      bindTestimonialsMediaLoad(section, slider, isMobile);
      if (isMobile) observeTestimonialsMobileHeight(section, slider);

      if (!window.theme?.Flickity) return;
      const flkty = window.theme.Flickity.data(slider);
      if (!flkty) return;

      flkty.options.draggable = !isMobile;
      if (typeof flkty.updateDraggable === 'function') {
        flkty.updateDraggable();
      }
      if (!isMobile && typeof flkty.resize === 'function') {
        flkty.resize();
      }
    };

    const runWhenReady = () => {
      if (window.theme?.Flickity?.data(slider) || slider.classList.contains('flickity-enabled')) {
        apply();
        return;
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(apply);
      });
    };

    runWhenReady();

    if (slider.dataset.twiFlickityWatch !== 'true') {
      slider.dataset.twiFlickityWatch = 'true';
      const flickityObserver = new MutationObserver(() => {
        if (!slider.classList.contains('flickity-enabled')) return;
        flickityObserver.disconnect();
        requestAnimationFrame(() => {
          requestAnimationFrame(apply);
        });
      });
      flickityObserver.observe(slider, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function syncAnnouncementHeight() {
    const bar = document.querySelector('[data-announcement-bar]');
    document.documentElement.style.setProperty(
      '--announcement-height',
      bar ? `${bar.clientHeight}px` : '0px'
    );
  }

  function initAnnouncementHeight() {
    syncAnnouncementHeight();
    requestAnimationFrame(syncAnnouncementHeight);
    window.addEventListener('resize', syncAnnouncementHeight);
    document.addEventListener('theme:resize', syncAnnouncementHeight);
  }

  function initTestimonialsWithImages(section) {
    if (!section || section.dataset.twiInit === 'true') return;
    section.dataset.twiInit = 'true';

    const slider = section.querySelector('[data-slider]');
    if (!slider) return;

    function applyLayout() {
      setTestimonialsMobileGrid(section, slider, !DESKTOP_MQ.matches);
    }

    DESKTOP_MQ.addEventListener('change', applyLayout);
    applyLayout();
  }

  function initAllTestimonialsWithImages(container) {
    const scope = container || document;
    scope.querySelectorAll('[data-testimonials-mobile-grid]').forEach(initTestimonialsWithImages);
  }

  function initProductDescriptionReadMore(root) {
    const scope = root || document;
    const ANIM_MS = 250;
    const reducedMotionMq = window.matchMedia('(prefers-reduced-motion: reduce)');

    scope.querySelectorAll('[data-noomus-desc-read-more]').forEach((block) => {
      if (block.dataset.descReadMoreInit === 'true') return;
      block.dataset.descReadMoreInit = 'true';

      const toggle = block.querySelector('[data-noomus-desc-toggle]');
      const content = block.querySelector('.noomus-product-description__content');
      const labelEl = block.querySelector('[data-noomus-desc-toggle-text]');
      if (!toggle || !content) return;

      const moreLabel = toggle.dataset.readMoreLabel || 'Read more';
      const lessLabel = toggle.dataset.readLessLabel || 'Read less';

      function clearAnimStyles() {
        content.style.height = '';
        content.style.overflow = '';
        content.style.transition = '';
      }

      function measureCollapsedHeight() {
        const wasExpanded = block.classList.contains('is-expanded');
        if (wasExpanded) block.classList.remove('is-expanded');
        const height = content.clientHeight;
        if (wasExpanded) block.classList.add('is-expanded');
        return height;
      }

      function animateHeight(from, to, onDone) {
        if (reducedMotionMq.matches) {
          clearAnimStyles();
          onDone();
          return;
        }

        content.style.overflow = 'hidden';
        content.style.height = `${from}px`;
        content.style.transition = `height ${ANIM_MS}ms ease`;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            content.style.height = `${to}px`;
          });
        });

        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          content.removeEventListener('transitionend', onEnd);
          clearAnimStyles();
          onDone();
        };

        content.addEventListener('transitionend', onEnd);
      }

      function contentOverflows() {
        block.classList.remove('is-expanded');
        const overflows = content.scrollHeight > content.clientHeight + 2;
        return overflows;
      }

      function syncToggleVisibility() {
        if (block.classList.contains('is-expanded')) {
          toggle.hidden = false;
          return;
        }
        toggle.hidden = !contentOverflows();
      }

      toggle.addEventListener('click', () => {
        if (block.dataset.descAnimating === 'true') return;

        const isExpanded = block.classList.contains('is-expanded');

        if (!isExpanded) {
          if (reducedMotionMq.matches) {
            block.classList.add('is-expanded');
            toggle.setAttribute('aria-expanded', 'true');
            if (labelEl) labelEl.textContent = lessLabel;
            return;
          }

          const from = content.clientHeight;
          block.classList.add('is-expanded');
          const to = content.scrollHeight;

          block.dataset.descAnimating = 'true';
          toggle.setAttribute('aria-expanded', 'true');
          if (labelEl) labelEl.textContent = lessLabel;

          animateHeight(from, to, () => {
            block.dataset.descAnimating = 'false';
          });
          return;
        }

        if (reducedMotionMq.matches) {
          block.classList.remove('is-expanded');
          toggle.setAttribute('aria-expanded', 'false');
          if (labelEl) labelEl.textContent = moreLabel;
          syncToggleVisibility();
          return;
        }

        const from = content.scrollHeight;
        const to = measureCollapsedHeight();

        block.dataset.descAnimating = 'true';
        animateHeight(from, to, () => {
          block.classList.remove('is-expanded');
          block.dataset.descAnimating = 'false';
          toggle.setAttribute('aria-expanded', 'false');
          if (labelEl) labelEl.textContent = moreLabel;
          syncToggleVisibility();
        });
      });

      syncToggleVisibility();

      if (document.fonts && typeof document.fonts.ready?.then === 'function') {
        document.fonts.ready.then(syncToggleVisibility);
      }

      block.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', syncToggleVisibility, { once: true });
      });
    });
  }

  function initReviewsLinkScroll() {
    if (document.documentElement.dataset.reviewsLinkInit === 'true') return;
    document.documentElement.dataset.reviewsLinkInit = 'true';

    document.addEventListener(
      'click',
      (event) => {
        const link = event.target.closest('[data-reviews-link]');
        if (!link) return;

        event.preventDefault();

        const raw =
          (window.innerWidth > 768
            ? link.getAttribute('data-target-desktop')
            : link.getAttribute('data-target-mobile') || link.getAttribute('data-target-desktop')) || '';

        const sel = raw.trim();
        const candidates = [];

        if (sel) candidates.push(sel);

        if (sel && sel[0] !== '#' && sel[0] !== '.') {
          candidates.push(`#${sel}`);
          candidates.push(`.${sel}`);
        }

        let target = null;
        for (let i = 0; i < candidates.length && !target; i += 1) {
          try {
            target = document.querySelector(candidates[i]);
          } catch (_) {
            /* invalid selector */
          }
        }

        if (!target) {
          target = document.querySelector(
            '[data-reviews-anchor], .section--reviews, #reviews, [id*="testimonials"], [id*="Testimonials"]'
          );
        }

        if (!target) return;

        const stickyOffset = 0;
        const y = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      },
      { passive: false }
    );
  }

  function equalizeUpsellCardHeights(slider) {
    if (!slider) return;
    const cards = slider.querySelectorAll('.upsell-card-item');
    if (!cards.length) return;

    cards.forEach((card) => {
      card.style.height = '';
    });

    let max = 0;
    cards.forEach((card) => {
      max = Math.max(max, card.offsetHeight);
    });

    if (max < 1) return;

    cards.forEach((card) => {
      card.style.height = `${max}px`;
    });

    const viewport = slider.querySelector('.flickity-viewport');
    if (viewport) {
      viewport.style.height = `${max}px`;
    }
  }

  function initUpsellCardsEqualize(section) {
    if (!section || section.dataset.upsellEqInit === 'true') return;
    section.dataset.upsellEqInit = 'true';

    const slider = section.querySelector('[data-slider]');
    if (!slider) return;

    let resizeTimer = 0;
    const run = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => equalizeUpsellCardHeights(slider));
      });
    };
    const runDebounced = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(run, 100);
    };

    const runWhenReady = () => {
      run();
    };

    runWhenReady();

    if (slider.dataset.upsellFlickityWatch !== 'true') {
      slider.dataset.upsellFlickityWatch = 'true';
      const flickityObserver = new MutationObserver(() => {
        if (!slider.classList.contains('flickity-enabled')) return;
        flickityObserver.disconnect();
        run();
      });
      flickityObserver.observe(slider, { attributes: true, attributeFilter: ['class'] });
    }

    slider.querySelectorAll('img').forEach((img) => {
      if (img.complete) return;
      img.addEventListener('load', run, { once: true });
      img.addEventListener('error', run, { once: true });
    });

    if (document.fonts && typeof document.fonts.ready?.then === 'function') {
      document.fonts.ready.then(run);
    }

    window.addEventListener('resize', runDebounced);
    document.addEventListener('theme:resize', runDebounced);
  }

  function initAllUpsellCards(container) {
    const scope = container || document;
    scope.querySelectorAll('[data-upsell-cards]').forEach(initUpsellCardsEqualize);
  }

  function closeCartGiftDropdown(root) {
    if (!root) return;
    const list = root.querySelector('[data-cart-gift-list]');
    const trigger = root.querySelector('[data-cart-gift-trigger]');
    root.classList.remove('is-open');
    if (list) list.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function toggleCartGiftDropdown(root) {
    if (!root || root.classList.contains('cart-footer-gift--locked')) return;
    const list = root.querySelector('[data-cart-gift-list]');
    const trigger = root.querySelector('[data-cart-gift-trigger]');
    const isOpen = root.classList.contains('is-open');
    if (isOpen) {
      closeCartGiftDropdown(root);
      return;
    }
    root.classList.add('is-open');
    if (list) list.hidden = false;
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function applyCartGiftOption(root, option) {
    if (!root || !option) return;
    const title = option.getAttribute('data-title') || '';
    const image = option.getAttribute('data-image') || '';
    const variantId = option.getAttribute('data-variant-id') || '';
    const triggerText = root.querySelector('[data-cart-gift-trigger-text]');
    const media = root.querySelector('[data-cart-gift-image]');
    const variantInput = root.querySelector('[data-cart-gift-variant]');

    if (triggerText) triggerText.textContent = title;
    if (media && media.tagName === 'IMG') {
      if (image) media.src = image;
      if (title) media.alt = title;
    }
    if (variantInput) variantInput.value = variantId;

    root.querySelectorAll('[data-cart-gift-option]').forEach((el) => {
      const selected = el === option;
      el.classList.toggle('is-selected', selected);
      el.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    closeCartGiftDropdown(root);
  }

  function setCartGiftButtonState(root, locked) {
    const button = root.querySelector('[data-cart-gift-add]');
    const addLabel = root.getAttribute('data-add-label') || 'Add Gift';
    const selectedLabel = root.getAttribute('data-selected-label') || 'Gift selected';
    const textEl = button && button.querySelector('[data-cart-gift-add-text]');

    root.classList.toggle('cart-footer-gift--locked', locked);

    if (!button) return;

    if (locked) {
      button.setAttribute('disabled', '');
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('cart-footer-gift__add--selected');
      if (textEl) textEl.textContent = selectedLabel;
      closeCartGiftDropdown(root);
      return;
    }

    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    button.classList.remove('cart-footer-gift__add--selected');
    if (textEl) textEl.textContent = addLabel;
  }

  function cartGiftIds(root) {
    return String(root.getAttribute('data-gift-ids') || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
  }

  function isSelectorGiftLine(item, giftIds) {
    const props = item.properties || {};
    return String(props._gift) === '1' && giftIds.indexOf(String(item.product_id)) !== -1;
  }

  function cartRequestUrl(path) {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + path;
  }

  async function cartJson(path, body) {
    const response = await fetch(cartRequestUrl(path), {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: body ? JSON.stringify(body) : undefined
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) {
      const error = new Error(data.description || data.message || 'Could not update the cart.');
      error.payload = data;
      throw error;
    }
    return data;
  }

  let cartGiftNormalizing = false;
  let cartGiftAddBusy = false;

  function cartGiftLines(cart, giftIds) {
    return (cart.items || []).filter((item) => isSelectorGiftLine(item, giftIds));
  }

  function cartPaidLines(cart, giftIds) {
    return (cart.items || []).filter((item) => !isSelectorGiftLine(item, giftIds));
  }

  async function enforceOneCartGift(root, cart) {
    const giftIds = cartGiftIds(root);
    const giftLines = cartGiftLines(cart, giftIds);
    const paidLines = cartPaidLines(cart, giftIds);
    if (!giftLines.length) return { cart: cart, changed: false };

    const updates = {};
    if (!paidLines.length) {
      giftLines.forEach((line) => {
        updates[line.key] = 0;
      });
    } else {
      giftLines.forEach((line, index) => {
        const keep = index === 0 ? 1 : 0;
        if (line.quantity !== keep) updates[line.key] = keep;
      });
    }

    const keys = Object.keys(updates);
    if (!keys.length) return { cart: cart, changed: false };

    cartGiftNormalizing = true;
    try {
      const next = await cartJson('cart/update.js', { updates: updates });
      if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
      return { cart: next, changed: true };
    } finally {
      cartGiftNormalizing = false;
    }
  }

  function syncCartFooterGift() {
    if (cartGiftNormalizing) return;
    const root = document.querySelector('#cart-drawer [data-cart-footer-gift]');
    if (!root) return;

    cartJson('cart.js')
      .then((cart) => enforceOneCartGift(root, cart))
      .then((result) => {
        const giftIds = cartGiftIds(root);
        const paidLines = cartPaidLines(result.cart, giftIds);
        const giftInCart = cartGiftLines(result.cart, giftIds).length > 0 && paidLines.length > 0;
        root.classList.toggle('hidden', paidLines.length === 0);
        setCartGiftButtonState(root, giftInCart);
      })
      .catch(() => {});
  }

  async function addCartGift(root) {
    if (!root || cartGiftAddBusy || root.classList.contains('cart-footer-gift--locked')) return;
    const button = root.querySelector('[data-cart-gift-add]');
    const textEl = button && button.querySelector('[data-cart-gift-add-text]');
    const variantInput = root.querySelector('[data-cart-gift-variant]');
    const variantId = variantInput ? variantInput.value : '';
    const addLabel = root.getAttribute('data-add-label') || 'Add Gift';
    if (!variantId) return;

    cartGiftAddBusy = true;
    if (button) button.disabled = true;

    try {
      let cart = await cartJson('cart.js');
      const enforced = await enforceOneCartGift(root, cart);
      cart = enforced.cart;
      const giftIds = cartGiftIds(root);
      if (!cartPaidLines(cart, giftIds).length) {
        root.classList.add('hidden');
        if (button) button.disabled = false;
        return;
      }
      if (cartGiftLines(cart, giftIds).length) {
        setCartGiftButtonState(root, true);
        return;
      }

      await cartJson('cart/add.js', {
        items: [{
          id: Number(variantId),
          quantity: 1,
          properties: { _gift: '1' }
        }]
      });
      setCartGiftButtonState(root, true);
      if (window.cart && typeof window.cart.getCart === 'function') window.cart.getCart();
    } catch (error) {
      if (button) button.disabled = false;
      if (textEl) textEl.textContent = error.message || 'Could not add gift';
      window.setTimeout(() => {
        if (textEl && !root.classList.contains('cart-footer-gift--locked')) textEl.textContent = addLabel;
      }, 2500);
    } finally {
      cartGiftAddBusy = false;
    }
  }

  function initCartFooterGift() {
    if (document.documentElement.dataset.cartGiftInit === 'true') return;
    document.documentElement.dataset.cartGiftInit = 'true';

    document.addEventListener('click', (event) => {
      const option = event.target.closest('[data-cart-gift-option]');
      const trigger = event.target.closest('[data-cart-gift-trigger]');
      const addButton = event.target.closest('[data-cart-gift-add]');
      const root = event.target.closest('[data-cart-footer-gift]');

      document.querySelectorAll('#cart-drawer [data-cart-footer-gift]').forEach((el) => {
        if (el !== root) closeCartGiftDropdown(el);
      });

      if (addButton) {
        event.preventDefault();
        event.stopPropagation();
        addCartGift(addButton.closest('[data-cart-footer-gift]'));
        return;
      }

      if (option) {
        event.preventDefault();
        applyCartGiftOption(option.closest('[data-cart-footer-gift]'), option);
        return;
      }

      if (trigger) {
        event.preventDefault();
        toggleCartGiftDropdown(trigger.closest('[data-cart-footer-gift]'));
        return;
      }

      document.querySelectorAll('#cart-drawer [data-cart-footer-gift]').forEach(closeCartGiftDropdown);
    });

    document.addEventListener('theme:cart:loaded', syncCartFooterGift);
    document.addEventListener('theme:cart:added', syncCartFooterGift);
  }

  function moveSoldOutCardsLast(wrapper) {
    if (!wrapper) return;
    Array.from(wrapper.children).forEach((card) => {
      if (card.classList && card.classList.contains('soldout')) {
        wrapper.appendChild(card);
      }
    });
  }

  function initRecentlyViewedSoldOutLast() {
    if (!window.Shopify || !Shopify.Products || typeof Shopify.Products.showRecentlyViewed !== 'function') return;
    if (Shopify.Products.showRecentlyViewed.__noomusSoldOutLast) return;

    const original = Shopify.Products.showRecentlyViewed.bind(Shopify.Products);
    function showRecentlyViewed(params) {
      const userComplete = params && params.onComplete;
      const next = Object.assign({}, params, {
        onComplete: function (wrapper, section) {
          moveSoldOutCardsLast(wrapper);
          if (typeof userComplete === 'function') userComplete(wrapper, section);
        }
      });
      return original(next);
    }
    showRecentlyViewed.__noomusSoldOutLast = true;
    Shopify.Products.showRecentlyViewed = showRecentlyViewed;
  }

  function initCartCoupon() {
    if (window.__noomusCartCoupon) return;
    window.__noomusCartCoupon = true;

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    let busy = false;

    function panels() {
      return document.querySelectorAll('[data-cart-coupon]');
    }

    function normalize(value) {
      return String(value || '').trim().toUpperCase();
    }

    function setStatus(message, tone) {
      panels().forEach(function (panel) {
        const node = panel.querySelector('[data-cart-coupon-status]');
        const input = panel.querySelector('[data-cart-coupon-code]');
        if (node) {
          node.textContent = message || '';
          node.hidden = !message;
          if (tone) node.dataset.tone = tone;
          else delete node.dataset.tone;
        }
        if (input) input.setAttribute('aria-invalid', tone === 'error' ? 'true' : 'false');
      });
    }

    function lock(on) {
      panels().forEach(function (panel) {
        panel.querySelectorAll('button, input').forEach(function (node) {
          node.disabled = on;
        });
      });
    }

    function codesOf(cart) {
      return (cart.discount_codes || []).map(function (item) {
        return normalize(item.code);
      }).filter(Boolean);
    }

    function render(cart) {
      const applicable = (cart.discount_codes || []).filter(function (item) {
        return item.applicable;
      });
      panels().forEach(function (panel) {
        const holder = panel.querySelector('[data-cart-coupon-tags]');
        if (!holder) return;
        holder.replaceChildren();
        applicable.forEach(function (item) {
          const code = normalize(item.code);
          const tag = document.createElement('span');
          const text = document.createElement('span');
          const remove = document.createElement('button');
          tag.className = 'cart-coupon__tag';
          text.textContent = code;
          remove.type = 'button';
          remove.className = 'cart-coupon__remove';
          remove.dataset.cartCouponRemove = code;
          remove.setAttribute('aria-label', 'Remove coupon ' + code);
          remove.textContent = '×';
          tag.append(text, remove);
          holder.append(tag);
        });
        holder.hidden = holder.childElementCount === 0;
      });
    }

    async function cartRequest(endpoint, body) {
      const response = await fetch(root + endpoint, {
        method: body ? 'POST' : 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: body ? JSON.stringify(body) : undefined
      });
      const data = await response.json();
      if (!response.ok || data.status >= 400) {
        throw new Error(data.description || data.message || 'Could not update the cart.');
      }
      return data;
    }

    function refreshDrawer() {
      if (window.cart && typeof window.cart.getCart === 'function') {
        window.cart.getCart();
      }
    }

    async function applyCode(raw) {
      const code = normalize(raw);
      if (!code) {
        setStatus('Enter a coupon code.', 'error');
        return;
      }
      let cart = await cartRequest('cart.js');
      const codes = codesOf(cart).filter(function (existing, index, list) {
        return list.indexOf(existing) === index;
      });
      if (codes.indexOf(code) === -1) codes.push(code);
      cart = await cartRequest('cart/update.js', { discount: codes.join(',') });
      const match = (cart.discount_codes || []).find(function (item) {
        return normalize(item.code) === code;
      });
      if (!match || !match.applicable) {
        const kept = codesOf(cart).filter(function (existing) {
          return existing !== code;
        });
        cart = await cartRequest('cart/update.js', { discount: kept.join(',') });
        render(cart);
        setStatus("That coupon isn't valid for this cart.", 'error');
        refreshDrawer();
        return;
      }
      panels().forEach(function (panel) {
        const input = panel.querySelector('[data-cart-coupon-code]');
        if (input) input.value = '';
      });
      render(cart);
      setStatus('Coupon applied.');
      refreshDrawer();
    }

    async function removeCode(code) {
      const target = normalize(code);
      let cart = await cartRequest('cart.js');
      const kept = codesOf(cart).filter(function (existing) {
        return existing !== target;
      });
      cart = await cartRequest('cart/update.js', { discount: kept.join(',') });
      render(cart);
      setStatus('');
      refreshDrawer();
    }

    async function syncFromCart() {
      if (!panels().length) return;
      try {
        render(await cartRequest('cart.js'));
      } catch (error) {
        return;
      }
    }

    async function run(task) {
      if (busy) return;
      busy = true;
      lock(true);
      try {
        await task();
      } catch (error) {
        setStatus(error.message || 'Could not update the cart.', 'error');
      } finally {
        busy = false;
        lock(false);
      }
    }

    document.addEventListener('click', function (event) {
      const apply = event.target.closest('[data-cart-coupon-apply]');
      const remove = event.target.closest('[data-cart-coupon-remove]');
      if (!apply && !remove) return;
      event.preventDefault();
      if (apply) {
        const input = apply.closest('[data-cart-coupon]').querySelector('[data-cart-coupon-code]');
        run(function () { return applyCode(input ? input.value : ''); });
      } else {
        run(function () { return removeCode(remove.dataset.cartCouponRemove); });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || !event.target.matches('[data-cart-coupon-code]')) return;
      event.preventDefault();
      run(function () { return applyCode(event.target.value); });
    });

    document.addEventListener('theme:cart:loaded', syncFromCart);
    document.addEventListener('theme:cart:added', syncFromCart);
  }

  function initOnReady() {
    initPhoneValidation();
    initAllColGrids();
    initAllTestimonialsWithImages();
    initAllUpsellCards();
    initAnnouncementHeight();
    initProductDescriptionReadMore();
    initReviewsLinkScroll();
    initCartFooterGift();
    initCartCoupon();
    initRecentlyViewedSoldOutLast();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnReady);
  } else {
    initOnReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllColGrids(event.target);
    initAllTestimonialsWithImages(event.target);
    initAllUpsellCards(event.target);
    initProductDescriptionReadMore(event.target);
    syncAnnouncementHeight();
    requestAnimationFrame(syncAnnouncementHeight);
  });
})();
